// scroll bar
import ReactDOM from 'react-dom';
import 'simplebar/src/simplebar.css';
//
import './index.css'
import App from './App';
import installAuthInterceptor from './utils/authInterceptor';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

// ----------------------------------------------------------------------

// Registered before the first render so every request is covered.
installAuthInterceptor();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
